function __variableDynamicImportRuntime0__(path) {
  switch (path) {
    case './plugins/web-personalization.ts': return import('./plugins/web-personalization.mjs');
    default: return new Promise(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }

// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
/**
 * A function that iterates through noted plugins and settings
 * and loads the retrieved plugins for engage. The plugins should be in form of functions.
 * @param settingsInput - The settings input from the developer
 */
async function loadPlugins(settingsInput) {
    let count = 0;
    const availablePluginsKeys = Object.keys(AvailablePlugins);
    const requiredSettings = {
        clientKey: settingsInput.clientKey,
        pointOfSale: settingsInput.pointOfSale,
        targetURL: settingsInput.targetURL,
    };
    for await (const key of availablePluginsKeys) {
        const pluginValue = settingsInput[key];
        if (!pluginValue)
            continue;
        const module = await __variableDynamicImportRuntime0__(`./plugins/${AvailablePlugins[key]}.ts`);
        const plugin = module.default;
        await plugin(pluginValue, requiredSettings);
        count++;
    }
    return Promise.resolve(`${count} plugins loaded`);
}
/**
 * enum with all available plugins
 * The path should be relative to the load-plugins.ts file
 * The name of each key should correspond to the property of the equivalent input setting
 */
var AvailablePlugins;
(function (AvailablePlugins) {
    AvailablePlugins["webPersonalization"] = "web-personalization";
})(AvailablePlugins || (AvailablePlugins = {}));

export { AvailablePlugins, loadPlugins };
